/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import TermoUsoView from '../views/TermoUsoView.vue'
import PoliticaView from '../views/PoliticaView.vue'
import CidadeView from '../views/CidadeView.vue'
import SobreNosView from '../views/SobreNosView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/termos-de-uso',
    name: 'termos-de-uso',
    component: TermoUsoView
  },
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    component: PoliticaView
  },
  {
    path: '/cidades-atendidas',
    name: 'cidades-atendidas',
    component: CidadeView
  },
  {
    path: '/sobre-nos',
    name: 'sobre-nos',
    component: SobreNosView
  },
  {
    path: '/#planos',
    name: 'Planos',
    component: HomeView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { left: 0, top: 0 };
    }
  },
})

export default router
/* eslint-enable */
